// extracted by mini-css-extract-plugin
export var infoSection = "_t-1";
export var infoSectionContainer = "_t-0";
export var infoSectionTitleRow = "_t-2";
export var multiLineInfo = "_t-4";
export var strong = "_t-3";